import { FC, ReactNode } from 'react';
import { KalenderhändelsearkivResponse } from '../../types/pages';
import PageInfo from '../../components/PageInfo/PageInfo';
import styles from './Kalenderhändelsearkiv.module.css';
import Kalender from '../../components/Kalender/Kalender';
import { ContentResponse } from '../../types/shared';

interface IKalenderhändelsearkivProps {
  contentResponse: ContentResponse;
}

const KalenderArkiv: FC<IKalenderhändelsearkivProps> = ({ contentResponse }): ReactNode => {
  const kalenderhändelsearkiv = contentResponse.content as KalenderhändelsearkivResponse;

  return (
    <div className={styles.container}>
      <PageInfo variant="breadcrumbs" contentResponse={contentResponse}></PageInfo>
      <Kalender response={kalenderhändelsearkiv}></Kalender>
    </div>
  );
};

export default KalenderArkiv;
